import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { isClientSuspended } from '../../store/cart.selectors';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Route guard that blocks suspended users from booking-related routes (e.g. facility,
 * facility-detail, booking-cart). Acts as a secondary layer if a user bypasses UI restrictions via direct URL.
 * Redirects to My Bookings and optionally shows a warning notification.
 */
@Injectable({
  providedIn: 'root',
})
export class SuspendedClientGuard implements CanActivate {
  constructor(
    private store: Store<unknown>,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(isClientSuspended).pipe(
      take(1),
      map((suspended) => {
        if (suspended) {
          this.router.navigate(['bookings']);
          this.snackBar.open(
            'Your account is currently suspended. You cannot make new bookings. Please use My Bookings for payments or contact support.',
            'OK',
            { duration: 5000 }
          );
          return false;
        }
        return true;
      })
    );
  }
}
